import { createInsightsMiddleware as _createInsightsMiddleware } from 'instantsearch.js/es/middlewares'
import aa from 'search-insights'

aa('init', {
  appId: FONTAWESOME.ALGOLIA_APPLICATION_ID,
  apiKey: FONTAWESOME.ALGOLIA_SEARCH_API_KEY,
  useCookie: true
})

export { aa }

export function createInsightsMiddleware() {
  return _createInsightsMiddleware({
    insightsClient: aa,
    onEvent: (event, aa) => {
      const { insightsMethod, payload } = event
      aa(insightsMethod, payload)
    }
  })
}
